var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"lesson"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require('@/assets/images/lesson-dummy.jpg'),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }